module.exports = __webpack_public_path__ + "img/signin.25610e75.svg";